module.exports = __webpack_public_path__ + "static/media/rein.66dff5e9.jpg";